<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="container-fluid">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <vs-button icon="arrow_back" to="/products">{{
                    $t("back")
                  }}</vs-button>
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <router-link
                    :to="{
                      name: 'Product Edit',
                      params: { id: $route.params.id },
                    }"
                  >
                    <vs-button icon="edit">{{ $t("edit") }}</vs-button>
                  </router-link>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-md="12"
                >
                  <h3>{{ header }}</h3>
                </vs-col>
              </vs-row>

              <div class="row mt-6 orta">
                <div class="col-md-7 shadow-lg mb-5 bg-white rounded">
                  <iframe
                    v-if="link_iframe != ''"
                    id="iframes"
                    :src="link_iframe"
                    height="500px"
                    width="100%"
                    frameborder="0"
                    v-on:load="iframeLoad"
                  ></iframe>
                </div>
              </div>
              <vx-card>
                <div class="header text-center mb-6">
                  <h1>{{ $t("info") }}</h1>
                </div>
                <Detail
                  :id="$route.params.id"
                  @headerName="getHeader"
                  @getData="photosData"
                  @alldata="fulldata"
                  @clientId="getClientId"
                ></Detail>
              </vx-card>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Detail from "./Detail Tabs/Info";

export default {
  components: {
    Detail,
  },
  data() {
    return {
      header: this.$route.params.name,
      photos: [],
      link_iframe: "",
      iframeDocument: "",
      completeData: [],
    };
  },
  methods: {
    iframeLoad() {
      this.iframe = document.getElementById("iframes");
      this.iframeDocument = this.iframe.contentDocument.querySelector("div");
      if (this.completeData.length > 0) {
        this.completeData.forEach((item, index) => {
          if (index == 0)
            this.iframeDocument.setAttribute(
              "data-reverse_spin",
              this.completeData[0].settingValue
            );
          if (index == 1)
            this.iframeDocument.setAttribute(
              "data-manual_spin_interaction",
              this.completeData[1].settingValue
            );
          if (index == 2)
            this.iframeDocument.setAttribute(
              "data-manual_spin_sensitivity",
              this.completeData[2].settingValue
            );
          if (index == 3)
            this.iframeDocument.setAttribute(
              "data-manual_spin_inertia",
              this.completeData[3].settingValue
            );
          if (index == 5)
            this.iframeDocument.setAttribute(
              "data-auto_spin",
              this.completeData[5].settingValue
            );
          if (index == 6)
            this.iframeDocument.setAttribute(
              "data-auto_spin_speed",
              this.completeData[6].settingValue
            );
          if (index == 8)
            this.iframeDocument.setAttribute(
              "data-zoom_speed",
              this.completeData[8].settingValue
            );
          if (index == 9)
            this.iframeDocument.setAttribute(
              "data-fullscreen_icon_variant",
              this.completeData[9].settingValue
            );
          if (index == 10)
            this.iframeDocument.setAttribute(
              "data-fullscreen_icon_size",
              this.completeData[10].settingValue
            );
          if (index == 12)
            this.iframeDocument.setAttribute(
              "data-background_color",
              this.completeData[12].settingValue
            );
          if (index == 16)
            this.iframeDocument.setAttribute(
              "data-fullscreen",
              this.completeData[16].settingValue
            );
          if (index == 17)
            this.iframeDocument.setAttribute(
              "data-zoom",
              this.completeData[17].settingValue
            );
          if (index == 18)
            this.iframeDocument.setAttribute(
              "data-manual_spin",
              this.completeData[18].settingValue
            );
          if (index == 19)
            this.iframeDocument.setAttribute(
              "data-auto_spin",
              this.completeData[19].settingValue
            );
        });
      }
    },
    getHeader(header) {
      this.header = header;
    },
    photosData(data) {
      data.forEach((element) => {
        this.photos.push(
          "https://api.360photoboxcloud.com/" + element.fileName
        );
      });
    },
    fulldata(data) {
      this.completeData = data;
    },
    getClientId(code) {
      this.link_iframe = `https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${code}`;
    },
  },
  created() {
    //this.link_iframe = `https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.$route.params.id}`;
  },
};
</script>

<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
.height {
  height: 450px !important;
}
</style>